import React, { useState } from "react";
import Button from "../Button";
import moment from "moment";
import TemplatePreview from "./TemplatePreview";

export default function TemplateOpenDialog({
  open,
  onClose,
  templates,
  loading,
  searchFilter,
  onSearchFilterChange,
  onApply,
  onFavourite,
  onUnfavourite,
  onDestroy,
}) {
  const [hoveredTemplate, setHoveredTemplate] = useState(null);
  const [appliedTemplateId, setAppliedTemplateId] = useState(null);

  if (!open) return null;

  const filteredTemplates = templates.filter(
    (tpl) => !searchFilter || tpl.name.toLowerCase().includes(searchFilter.toLowerCase())
  );

  const handleApply = (template) => {
    setAppliedTemplateId(template.id);
    onApply(template);
  };

  return (
    <div
      style={{
        position: "absolute",
        background: "white",
        border: "1px solid #ddd",
        zIndex: 10,
        maxHeight: 500,
        minWidth: hoveredTemplate ? 1040 : 640,
        width: hoveredTemplate ? 1040 : 640,
        maxWidth: "90vw",
        right: 0,
        top: "100%",
        marginTop: 5,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ display: "flex", flex: 1, minHeight: 0 }}>
        <TemplatePreview template={hoveredTemplate} />
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: 10,
              borderBottom: "1px solid #eee",
            }}
          >
            <strong>{I18n && I18n.t ? I18n.t("templates.templates") : "Templates"}</strong>
            <a onClick={onClose} style={{ cursor: "pointer" }}>
              close
            </a>
          </div>
          <div style={{ padding: 10 }}>
            {templates.length > 0 && (
              <div style={{ marginBottom: 10 }}>
                <input
                  ref={(input) => input && input.focus()}
                  className="form-control"
                  placeholder="Search templates..."
                  value={searchFilter}
                  onChange={(e) => onSearchFilterChange(e.target.value)}
                />
              </div>
            )}
            {templates.length === 0 && (
              <div style={{ color: "#777" }}>
                {I18n && I18n.t ? I18n.t("templates.no_templates") : "No templates yet"}
              </div>
            )}
            {filteredTemplates.length === 0 &&
              templates.length > 0 && (
                <div style={{ color: "#777" }}>No templates match your search</div>
              )}
            {filteredTemplates.length > 0 && (
              <div style={{ overflowY: "auto", flex: 1 }}>
                <table
                  className="table table-very-condensed table-striped table-hover"
                  style={{ marginBottom: 0, width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>{I18n && I18n.t ? I18n.t("templates.name") : "Name"}</th>
                      <th>{I18n && I18n.t ? I18n.t("templates.created_by") : "Created By"}</th>
                      <th>{I18n && I18n.t ? I18n.t("templates.created_at") : "Created"}</th>
                      <th style={{ width: 110, textAlign: "right" }}>
                        {I18n && I18n.t ? I18n.t("templates.actions") : ""}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTemplates.map((tpl) => (
                      <tr
                        key={tpl.id}
                        onMouseEnter={() => setHoveredTemplate(tpl)}
                        onMouseLeave={() => setHoveredTemplate(null)}
                        style={{
                          cursor: "pointer",
                          backgroundColor:
                            appliedTemplateId === tpl.id ? "#fffacd" : "transparent",
                        }}
                      >
                        <td style={{ wordBreak: "break-word", overflowWrap: "anywhere" }}>
                          <strong>{tpl.name}</strong>
                        </td>
                        <td>{(tpl.created_by && tpl.created_by.name) || ""}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {moment(tpl.created_at).format("DD-MM-YYYY")}
                        </td>
                        <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                          {tpl.owner && (
                            <Button tiny icon="fa-trash" onClick={() => onDestroy(tpl)} />
                          )}
                          &nbsp;
                          {tpl.favourited ? (
                            <Button 
                              tiny 
                              icon="fa-star" 
                              onClick={() => onUnfavourite(tpl)}
                              style={{ color: "#ffc107" }}
                            />
                          ) : (
                            <Button tiny icon="fa-star-o" onClick={() => onFavourite(tpl)} />
                          )}
                          &nbsp;
                          <Button
                            tiny
                            title={I18n && I18n.t ? I18n.t("templates.apply") : "apply"}
                            icon="fa-check"
                            onClick={() => handleApply(tpl)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
